// import React, { createContext, useContext, useEffect, useState } from "react";
// const UserContext = createContext();
// export const UserProvider = ({ children, action }) => {
//   const [role, setRole] = useState(null);
//   const [userAccess, setUserAccess] = useState(null);
//   const [headerCpaName, setHeaderCpaName] = useState();
//   const [headerCpaBranch, setHeaderCpaBranch] = useState();
//   const [headerCpaBranchEmp, setHeaderCpaBranchEmp] = useState();
//   useEffect(() => {
//     setRole(action);
//   }, [action]);
//   return (
//     <UserContext.Provider
//       value={{
//         role,
//         setRole,
//         userAccess,
//         setUserAccess,
//         headerCpaName,
//         setHeaderCpaName,
//         headerCpaBranch,
//         setHeaderCpaBranch,
//         headerCpaBranchEmp,
//         setHeaderCpaBranchEmp,
//       }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };

// export const useUser = () => {
//   return useContext(UserContext);
// };

import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

// Default context values
const UserContext = createContext({
  role: null,
  setRole: () => {},
  userAccess: null,
  setUserAccess: () => {},
  headerCpaName: "",
  setHeaderCpaName: () => {},
  headerCpaBranch: "",
  setHeaderCpaBranch: () => {},
  headerCpaBranchEmp: "",
  setHeaderCpaBranchEmp: () => {},
});

export const UserProvider = ({ children, action }) => {
  const [role, setRole] = useState(null);
  const [userAccess, setUserAccess] = useState(null);
  const [headerCpaName, setHeaderCpaName] = useState("");
  const [headerCpaBranch, setHeaderCpaBranch] = useState("");
  const [headerCpaBranchEmp, setHeaderCpaBranchEmp] = useState("");

  useEffect(() => {
    setRole(action);
  }, [action]);

  const value = useMemo(() => ({
    role,
    setRole,
    userAccess,
    setUserAccess,
    headerCpaName,
    setHeaderCpaName,
    headerCpaBranch,
    setHeaderCpaBranch,
    headerCpaBranchEmp,
    setHeaderCpaBranchEmp,
  }), [
    role,
    userAccess,
    headerCpaName,
    headerCpaBranch,
    headerCpaBranchEmp,
  ]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
